import _ from 'lodash';

function getObjectDiff(object, base) {
  function changes(object, base) {
    return _.transform(object, function(result, value, key) {
      if (!_.isEqual(value, base[key])) {
        result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
      }
    });
  }
  return changes(object, base);
}

function flattenObject(obj) {
  let returnable = {};
  let objKeys = Object.keys(obj);
  for (let i = 0; i < objKeys.length; i++) {
    if (typeof obj[objKeys[i]] === "object") {
      let aux = { ...returnable, ...flattenObject(obj[objKeys[i]]) };
      returnable = aux;
    } else {
      returnable[objKeys[i]] = obj[objKeys[i]];
    }
  }
  return returnable;
}

function areObjectsDifferent(object, base) {
  return !_.isEqual(object, base);
}

function objectContains(attributeToSearch, object) {
  if (typeof attributeToSearch !== 'string') return false; // Check if attributeToSearch is a string
  const attributes = attributeToSearch.split(".");
  let objectIterator = object;
  for (let i = 0; i < attributes.length; i++) {
    if (objectIterator[attributes[i]] !== undefined) {
      objectIterator = objectIterator[attributes[i]];
    } else {
      return false;
    }
  }
  return true;
}

function getAttributeValue(attributeToSearch, object) {
  if (!object || typeof attributeToSearch !== 'string') return undefined; // Ensure attributeToSearch is a string
  const attributes = attributeToSearch.split(".");
  let objectIterator = object;
  for (let i = 0; i < attributes.length; i++) {
    if (objectIterator[attributes[i]] !== undefined) {
      objectIterator = objectIterator[attributes[i]];
    } else {
      return undefined;
    }
  }
  return objectIterator;
}

function copyObject(object) {
  return JSON.parse(JSON.stringify(object));
}

function addAttributeToObject(attributeToSearch, value, object) {
  if (typeof attributeToSearch !== 'string') return object; // Ensure attributeToSearch is a string
  let newObject = { ...object };
  let objectIterator = newObject;
  const attributes = attributeToSearch.split('.');
  const len = attributes.length;
  for (let i = 0; i < len - 1; i++) {
    let elem = attributes[i];
    if (!objectIterator[elem]) {
      objectIterator[elem] = {};
    } else {
      objectIterator[elem] = { ...objectIterator[elem] };
    }
    objectIterator = objectIterator[elem];
  }
  objectIterator[attributes[len - 1]] = value;
  return newObject;
}

function removeAttributeFromObject(attributeToSearch, object) {
  if (typeof attributeToSearch !== 'string') return object; // Ensure attributeToSearch is a string
  let newObject = { ...object };
  let objectIterator = newObject;
  const attributes = attributeToSearch.split('.');
  const len = attributes.length;
  for (let i = 0; i < len - 1; i++) {
    let elem = attributes[i];
    if (objectIterator[elem] === undefined) {
      return object;
    } else {
      objectIterator[elem] = { ...objectIterator[elem] };
      objectIterator = objectIterator[elem];
    }
  }
  delete objectIterator[attributes[attributes.length - 1]];
  return newObject;
}

function isEmpty(object) {
  return _.isEmpty(object);
}

const ObjectUtils = {
  objectContains,
  getAttributeValue,
  addAttributeToObject,
  copyObject,
  removeAttributeFromObject,
  getObjectDiff,
  areObjectsDifferent,
  flattenObject,
  isEmpty,
};

export default ObjectUtils;
